// extracted by mini-css-extract-plugin
export default {"container":"Patient_container__+X8To","form-container":"Patient_form-container__MPtNi"};